import validate from "/application/node_modules/.pnpm/nuxt@3.15.1_@parcel+watcher@2.5.0_@types+node@22.10.1_db0@0.2.1_eslint@8.57.1_ioredis@5_1596d5bc1c592ff1dcc428e60f2821d4/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/application/src/middleware/auth.global.ts";
import localization_45global from "/application/src/middleware/localization.global.ts";
import manifest_45route_45rule from "/application/node_modules/.pnpm/nuxt@3.15.1_@parcel+watcher@2.5.0_@types+node@22.10.1_db0@0.2.1_eslint@8.57.1_ioredis@5_1596d5bc1c592ff1dcc428e60f2821d4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  localization_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}